import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import type { Theme } from 'src/theme';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(0.5, 2),
    textAlign: 'right'
  }
}));

interface VersionInfo {
  app: string;
  version: string;
  environment: string;
}

const Footer: FC = () => {
  const classes = useStyles();
  const [version, setVersion] = useState<VersionInfo | null>(null);

  useEffect(() => {
    let mounted = true;

    fetch('/version.json')
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (mounted && data) {
          setVersion(data);
        }
      })
      .catch(() => {
        // Sin version.json (build local, dev server) no se muestra nada.
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (!version) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Typography variant="caption" color="textSecondary">
        {`v${version.version}`}
      </Typography>
    </Box>
  );
};

export default Footer;
